import { DashboardFormType } from '@/types/dashboard'
import { UseAccess } from '@/types/hooks'

import { ListStatus } from '@elements/dashboard'

export enum CommonDredgingApprovalStatus {
  DRAFT = 'draft',
  REVIEW_MANAGER = 'review-manager',
  REVISION = 'revision',
  APPROVED = 'approved',
  REVIEW_VP = 'review-vp',
  PAYMENT_PROCESS = 'payment-process',
  REVIEW_STAFF_KEMITRAAN = 'review-staff',
  SUBMIT_MITRA = 'submit-mitra',
}

export enum CommonDredgingApprovalActionType {
  APPROVE = 'approval',
  REJECT = 'rejection',
}

export interface DredgingApprovalActionProps {
  configMutate: {
    url: string
    options?: {
      onSuccess?: () => void
    }
  }
  data: Record<string, unknown>

  preAjukanMutateAsync?: (variables: any) => Promise<any>
  preAjukanPayload?: any
  fallbackErrorPreAjukan?: () => void
}

export interface CommonDredgingApprovalActionProps {
  type: DashboardFormType
  access?: UseAccess
  statusApproval?: string | CommonDredgingApprovalStatus
  callbackRevisi?: (note: string) => void
  callbackApproved?: () => void
  moduleName?: string
  parentPath?: string
  hidden?: boolean
  showAjukan?: boolean
  actionAjukanProps?: Partial<DredgingApprovalActionProps>
  actionRevisiProps?: Partial<DredgingApprovalActionProps>
  actionApproveProps?: Partial<DredgingApprovalActionProps>
  instanceId?: string
  forceShowAjukan?: boolean
  className?: string
}

export type ExtendDredgingListStatus = ListStatus & {
  hide?: boolean
}
